var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useContext, useEffect, useState } from 'react';
import { VerticalCardLoader } from 'syf-component-library/ui/atoms';
import { generateUUID } from 'syf-js-utilities';
import { ConfigContext } from '../../context';
import { useAuthorizedUsersGet, useMultiAuthorizedUsersPostMutation } from '../../../../const/syf-api-queries';
import AuthorizedUsers from '../../main-container/components/AuthorizedUsers';
import CardHoldersFooter from '../../main-container/components/CardHoldersFooter';
import { BodyContainer, ModalContentWrapper } from './subcomponents';
import { AddAuthUserInputType, CardholdersScreen } from '../../typings';
import getInputErrorMessage from './helpers/get-input-error-message';
import { initialAddAuthState, initialErrorDetails } from '../../const';
import queryParamsToObject from '../../helpers/query-params-to-object';
import { ANALYTICS_PAYLOAD, INPUT_MISSING_DETAILS, PAGE_NAME } from '../../const/analytics';
import triggerManageCardHoldersAnalytics from '../../helpers/trigger-manage-card-holders-analytics';
import { RESPONSE_STATUS, STATUS_CODE } from '../../const/status-and-error-codes';
import { AddAuthorizedUsers, CardHoldersHeader } from '../../main-container/components';
import displayModalScreen from '../../helpers/display-modal-screen';
import { formatDateToISO } from '../../../../helpers/dateFormatter';
var ManageCardHoldersModalContent = function () {
    var _a = useContext(ConfigContext), config = _a.config, selectedAccountId = _a.selectedAccountId, handleClose = _a.handleClose;
    var _b = useState(initialAddAuthState), inputState = _b[0], setInputState = _b[1];
    var _c = useState(false), isUserVerified = _c[0], setIsUserVerified = _c[1];
    var _d = useState(false), isAddAuthUserSubmitted = _d[0], setIsAddAuthUserSubmitted = _d[1];
    var _e = useState(), newAddedAuthorizedUser = _e[0], setNewAddedAuthorizedUser = _e[1];
    var _f = useState({
        screen: CardholdersScreen.INITIAL_SCREEN
    }), currentScreen = _f[0], setCurrentScreen = _f[1];
    var _g = useState(initialErrorDetails), errorDetails = _g[0], setErrorDetails = _g[1];
    var otpErrorCallbackParams = sessionStorage.getItem('otpErrorCallbackParams');
    var _h = useAuthorizedUsersGet(selectedAccountId), authorizedUsersDataGet = _h.data, isGetAuthorizedError = _h.isError, isGetAuthorizedFetching = _h.isFetching, isGetAuthorizedSuccess = _h.isSuccess;
    var _j = useMultiAuthorizedUsersPostMutation(config), mutateAsync = _j.mutateAsync, postAuthorizedError = _j.error, isPostAuthorizedLoading = _j.isLoading;
    var hasError = isGetAuthorizedError ||
        (isUserVerified && Boolean(postAuthorizedError)) ||
        Boolean(errorDetails.businessErrorCode);
    var showLoader = !hasError && (isGetAuthorizedFetching || isPostAuthorizedLoading);
    var remainingAuthUsersAllowed = authorizedUsersDataGet === null || authorizedUsersDataGet === void 0 ? void 0 : authorizedUsersDataGet.remainingAuthUsersAllowed;
    var handleResponseError = useCallback(function (error) { return __awaiter(void 0, void 0, void 0, function () {
        var responseError, responseStatus, parsedError;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    responseError = error === null || error === void 0 ? void 0 : error.response;
                    responseStatus = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status;
                    if (!(responseStatus === (RESPONSE_STATUS === null || RESPONSE_STATUS === void 0 ? void 0 : RESPONSE_STATUS.FORBIDDEN) && !isUserVerified)) return [3 /*break*/, 1];
                    setCurrentScreen({
                        screen: CardholdersScreen.VERIFY_USER_SCREEN
                    });
                    return [3 /*break*/, 4];
                case 1:
                    if (!(responseStatus === RESPONSE_STATUS.BUSINESS_ERROR)) return [3 /*break*/, 3];
                    return [4 /*yield*/, (responseError === null || responseError === void 0 ? void 0 : responseError.json())];
                case 2:
                    parsedError = _b.sent();
                    setErrorDetails({
                        businessErrorCode: parsedError.businessErrors[0].code,
                        businessErrorDescription: parsedError.businessErrors[0].message
                    });
                    return [3 /*break*/, 4];
                case 3:
                    setErrorDetails(initialErrorDetails);
                    _b.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); }, [isUserVerified]);
    var handleScopeCheck = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 4]);
                    return [4 /*yield*/, mutateAsync({
                            'cipher.accountId': selectedAccountId,
                            accountIdType: 'guid',
                            authorizedUsers: []
                        })];
                case 1:
                    _a.sent();
                    setIsUserVerified(true);
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    return [4 /*yield*/, handleResponseError(error_1)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var clearFields = function () {
        setInputState(initialAddAuthState);
        setIsAddAuthUserSubmitted(false);
        setNewAddedAuthorizedUser(undefined);
        setErrorDetails(initialErrorDetails);
    };
    var changeScreen = function (screenProps) {
        setCurrentScreen(screenProps);
        if (hasError ||
            ![
                CardholdersScreen.ADD_AUTH_USER,
                CardholdersScreen.CONFIRMATION_SCREEN_NEW_USER
            ].includes(screenProps.screen)) {
            clearFields();
        }
    };
    var handleCancel = function () {
        handleClose();
        clearFields();
    };
    var updateState = function (_a) {
        var type = _a.type, value = _a.value;
        var inputErrorMessage = inputState[type].errorMessage;
        var hasInputAndErrorMessage = Boolean(value && inputErrorMessage);
        setInputState(function (prev) {
            var _a;
            return __assign(__assign({}, prev), (_a = {}, _a[type] = {
                errorMessage: !hasInputAndErrorMessage ? prev[type].errorMessage : '',
                value: value
            }, _a));
        });
    };
    var handleBlur = function (_a) {
        var type = _a.type;
        setInputState(function (prev) {
            var _a;
            var errorMessage = getInputErrorMessage(type, prev[type].value);
            return __assign(__assign({}, prev), (_a = {}, _a[type] = __assign(__assign({}, prev[type]), { value: prev[type].value.trim(), touched: true, errorMessage: errorMessage }), _a));
        });
    };
    var validateInputFields = function () {
        var valid = true;
        var updateInput = __assign({}, inputState);
        Object.entries(updateInput).forEach(function (values) {
            var field = values[0];
            var inputErrorMessage = getInputErrorMessage(field, updateInput[field].value);
            updateInput[field].errorMessage = inputErrorMessage;
            if (inputErrorMessage) {
                triggerManageCardHoldersAnalytics({
                    pageName: PAGE_NAME.ERROR,
                    errorMessage: INPUT_MISSING_DETAILS
                });
                valid = false;
            }
        });
        setInputState(updateInput);
        return valid;
    };
    // eslint-disable-next-line sonarjs/cognitive-complexity
    var handleAddAuthUserSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, response, responseAuthorizedUsers, authorizedUser, statusCode, postError, code, errorMessage, error_2;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setIsAddAuthUserSubmitted(true);
                    if (!validateInputFields()) return [3 /*break*/, 5];
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 5]);
                    payload = {
                        'cipher.accountId': selectedAccountId,
                        accountIdType: 'guid',
                        authorizedUsers: [
                            {
                                operationId: generateUUID(),
                                'cipher.firstName': inputState[AddAuthUserInputType.authorizedUserFirstName].value,
                                'cipher.lastName': inputState[AddAuthUserInputType.authorizedUserLastName].value,
                                'cipher.dateOfBirth': formatDateToISO(inputState[AddAuthUserInputType.authorizedUserBirthDate].value)
                            }
                        ]
                    };
                    return [4 /*yield*/, mutateAsync(payload)];
                case 2:
                    response = _d.sent();
                    responseAuthorizedUsers = response === null || response === void 0 ? void 0 : response.authorizedUsers;
                    if (responseAuthorizedUsers && (responseAuthorizedUsers === null || responseAuthorizedUsers === void 0 ? void 0 : responseAuthorizedUsers.length) > 0) {
                        authorizedUser = responseAuthorizedUsers === null || responseAuthorizedUsers === void 0 ? void 0 : responseAuthorizedUsers[0];
                        statusCode = authorizedUser.statusCode, postError = authorizedUser.error;
                        code = (_b = (_a = postError === null || postError === void 0 ? void 0 : postError.businessErrors) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.code;
                        errorMessage = ((_c = postError === null || postError === void 0 ? void 0 : postError.businessErrors) === null || _c === void 0 ? void 0 : _c[0].description) || '';
                        if (statusCode === STATUS_CODE.NEW_USER) {
                            triggerManageCardHoldersAnalytics({
                                pageName: PAGE_NAME.COMPLETE
                            });
                            setNewAddedAuthorizedUser({
                                authorizedUsers: payload.authorizedUsers
                            });
                            changeScreen({
                                screen: CardholdersScreen.CONFIRMATION_SCREEN_NEW_USER
                            });
                        }
                        else if (statusCode === STATUS_CODE.EXISTING_USER) {
                            changeScreen({
                                screen: CardholdersScreen.CONFIRMATION_SCREEN_EXISTING_USER
                            });
                        }
                        else if (code && statusCode === STATUS_CODE.BUSINESS_ERROR) {
                            setErrorDetails({
                                businessErrorCode: code,
                                businessErrorDescription: errorMessage
                            });
                        }
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _d.sent();
                    return [4 /*yield*/, handleResponseError(error_2)];
                case 4:
                    _d.sent();
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (hasError) {
            var businessErrorCode = errorDetails.businessErrorCode, businessErrorDescription = errorDetails.businessErrorDescription;
            var analyticsError = businessErrorCode && Boolean(ANALYTICS_PAYLOAD[businessErrorCode])
                ? ANALYTICS_PAYLOAD[businessErrorCode]
                : ANALYTICS_PAYLOAD.api_failure;
            triggerManageCardHoldersAnalytics(analyticsError
                ? __assign(__assign({}, analyticsError), { errorMessage: businessErrorDescription }) : {
                pageName: PAGE_NAME.API_FAILURE,
                errorMessage: 'server error'
            });
            setCurrentScreen({
                screen: CardholdersScreen.ERROR_SCREEN,
                customData: { businessErrorCode: businessErrorCode }
            });
        }
    }, [errorDetails, hasError]);
    useEffect(function () {
        if (isGetAuthorizedSuccess &&
            remainingAuthUsersAllowed &&
            remainingAuthUsersAllowed !== '0' &&
            !otpErrorCallbackParams) {
            handleScopeCheck();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isGetAuthorizedSuccess,
        remainingAuthUsersAllowed,
        otpErrorCallbackParams
    ]);
    useEffect(function () {
        if (otpErrorCallbackParams) {
            var errorObjectParams = queryParamsToObject(otpErrorCallbackParams);
            var stepUpError = '';
            if ('error' in errorObjectParams) {
                stepUpError = errorObjectParams.error;
            }
            if (stepUpError) {
                triggerManageCardHoldersAnalytics(__assign({}, ANALYTICS_PAYLOAD[stepUpError]));
                if (stepUpError === 'user_declined') {
                    setCurrentScreen({ screen: CardholdersScreen.VERIFY_USER_SCREEN });
                }
                if (stepUpError === 'access_denied') {
                    setCurrentScreen({ screen: CardholdersScreen.ACCESS_DENIED_SCREEN });
                }
                else {
                    sessionStorage.removeItem('otpErrorCallbackParams');
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [otpErrorCallbackParams]);
    if (showLoader) {
        return (_jsx("div", __assign({ "data-testid": "skeleton-loader" }, { children: _jsx(VerticalCardLoader, {}) })));
    }
    var addAuthorizedUserScreen = currentScreen.screen === CardholdersScreen.ADD_AUTH_USER;
    var isNewUserConfirmationScreen = currentScreen.screen === CardholdersScreen.CONFIRMATION_SCREEN_NEW_USER;
    var showAuthorizedUser = !hasError && !addAuthorizedUserScreen;
    var showHeader = !hasError && !isNewUserConfirmationScreen;
    return (_jsxs(ModalContentWrapper, __assign({ id: "modal-content-wrapper" }, { children: [_jsxs(BodyContainer, { children: [showHeader && (_jsx(CardHoldersHeader, { usersLimit: remainingAuthUsersAllowed })), displayModalScreen(currentScreen), showAuthorizedUser && (_jsx(AuthorizedUsers, { authorizedUsers: isNewUserConfirmationScreen
                            ? newAddedAuthorizedUser
                            : authorizedUsersDataGet, currentScreen: currentScreen.screen, remainingAuthUserAllowed: remainingAuthUsersAllowed })), addAuthorizedUserScreen && (_jsx(AddAuthorizedUsers, __assign({}, {
                        authorizedUserInputValuesState: inputState,
                        handleBlur: handleBlur,
                        updateState: updateState,
                        isAddAuthUserSubmitted: isAddAuthUserSubmitted
                    })))] }), _jsx(CardHoldersFooter, { handleAddAuthUserSubmit: handleAddAuthUserSubmit, handleClose: handleCancel, changeScreen: changeScreen, currentScreen: currentScreen.screen, usersLimit: remainingAuthUsersAllowed })] })));
};
export default ManageCardHoldersModalContent;
